import { ChangeDetectionStrategy, Component, viewChild } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { MatSidenavContainer, MatSidenavContent } from "@angular/material/sidenav";
import { SidenavContentComponent } from "./sidenav-content/sidenav-content.component";

@Component({
  selector: "app-sidenav",
  imports: [MatSidenav, MatSidenavContainer, MatSidenavContent, SidenavContentComponent],
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent {
  drawer = viewChild.required(MatSidenav);

  async open(): Promise<void> {
    await this.drawer().open();
  }

  async close(): Promise<void> {
    await this.drawer().close();
  }

  async toggle(): Promise<void> {
    await this.drawer().toggle();
  }
}
